import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const inventoryListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}inventories?tab=${payload?.tab || ''}&paginate=${payload?.page || ''}&sort_order=${payload?.sort || ''}&sort=${payload?.sort_by || ''}&size=${payload?.length || ''}&search=${payload?.search || ''}&filter[inventory_type]=${payload?.inventory_type || ''}&filter[source]=${payload?.source || ''}&filter[bike_make_ids]=${payload?.bike_make_ids || ''}&filter[bike_model_ids]=${payload?.bike_model_ids || ''}&filter[bike_type_ids]=${payload?.bike_type_ids || ''}&filter[purchase_price_min]=${payload?.purchase_price_min || ''}&filter[purchase_price_max]=${payload?.purchase_price_max || ''}&filter[suggested_price_min]=${payload?.suggested_price_min || ''}&filter[suggested_price_max]=${payload?.suggested_price_max || ''}&filter[license_category_ids]=${payload?.license_category_ids || ''}&filter[stock_status]=${payload?.stock_status || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const inventoryDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}inventories/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data)
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(data);

                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const inventoryFiltersApi = async () => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}inventories/filters`, request);
        const data = await response.json();
        if (response.ok) return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

const inventoryGeneralOptionsApi = async (type) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}general?type=${type}`, request);
        const data = await response.json();
        if (response.ok) return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

export const inventoryStockStatusesApi = () => inventoryGeneralOptionsApi("erp_stock_statuses");

export const inventoryCreateApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}inventories`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const inventoryUpdateApi = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data)
    try {
        const response = await fetch(
            `${server}inventories/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const inventoryDeleteApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}inventories/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};
